import { render } from "./Player.vue?vue&type=template&id=3bcd0fed&scoped=true"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"

import "./Player.vue?vue&type=style&index=0&id=3bcd0fed&scoped=scoped&lang=css"
import "./Player.vue?vue&type=style&index=1&id=3bcd0fed&lang=less"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcd0fed"]])

export default __exports__